import { useDonation } from '../context/DonationContext'
import { useEffect, useState } from 'react'

export default function Overview() {
  const { state: { filteredDonations, masterDonations } } = useDonation()
  const [isClient, setIsClient] = useState(false)
  
  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) {
    return (
      <div id="overviewSection" className="flex-item">
        <div className="flex justify-between">
          <div className="bg-white p-3 rounded-lg shadow flex-1 mr-2">
            <h3 className="text-sm font-semibold text-secondary mb-1">Total Donations in Date Range</h3>
            <p id="totalDonations" className="text-2xl font-bold text-primary">Loading...</p>
          </div>
          <div className="bg-white p-3 rounded-lg shadow flex-1 mx-2">
            <h3 className="text-sm font-semibold text-secondary mb-1">Total Donors</h3>
            <p id="totalDonors" className="text-2xl font-bold text-primary">Loading...</p>
          </div>
        </div>
      </div>
    )
  }

  const totalDonationsCount = masterDonations.length
  const filteredDonationsCount = filteredDonations.length
  const uniqueDonors = new Set(filteredDonations.map(donation => donation.Email)).size


  return (
    <div id="overviewSection" className="flex-item">
      <div className="flex justify-between">
        <div className="bg-white p-3 rounded-lg shadow flex-1 mr-2">
          <h3 className="text-sm font-semibold text-secondary mb-1">Total Donations in Date Range</h3>
          <p id="totalDonations" className="text-2xl font-bold text-primary">{filteredDonationsCount} / {totalDonationsCount}</p>
        </div>
        <div className="bg-white p-3 rounded-lg shadow flex-1 mx-2">
          <h3 className="text-sm font-semibold text-secondary mb-1">Total Donors</h3>
          <p id="totalDonors" className="text-2xl font-bold text-primary">{uniqueDonors}</p>
        </div>
      </div>
    </div>
  )
}

